import { Box, Button, IconButton, Slider, Table, TableBody, TableCell, TableHead, TableRow, TextField, Typography } from "@mui/material"
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import useAuth from "../../../hooks/useAuth";

const AssetTypeAllocation = ({
	allocations,
	remainingTarget,
	onUpdate,
	onSave,
	size = 'medium',
	isSaving = false
}) => {
	const isCompact = size === 'small';
	const { auth } = useAuth()
	
	// Se os usuario nao for administrador, mostra apenas STOCKS e ACOES
	const filteredAllocations = auth.userId > 100 ? allocations.filter(item => item.assetType === 'STOCK' || item.assetType === 'ACAO') : allocations

	const handleAdjustTarget = (label, delta) => {
		if (!onUpdate) return;
		const total = filteredAllocations.reduce((acc, i) => acc + i.planned, 0);
		const next = filteredAllocations.map(item => {
			if (item.label !== label) return item;
			const nextValue = Math.max(0, Math.min(100, item.planned + delta));
			const nextTotal = total - item.planned + nextValue;
			if (nextTotal > 100) return item;
			return { ...item, planned: nextValue, diff: (item.current || 0) - nextValue };
		});
		onUpdate(next);
	};

	const handleManualTarget = (label, value) => {
		if (!onUpdate) return;
		const parsed = Number.parseInt(value, 10);
		const nextValue = Number.isNaN(parsed) ? 0 : Math.max(0, Math.min(100, parsed));
		const total = filteredAllocations.reduce((acc, i) => acc + i.planned, 0);
		const next = filteredAllocations.map(item => {
			if (item.label !== label) return item;
			const nextTotal = total - item.planned + nextValue;
			if (nextTotal > 100) return item;
			return { ...item, planned: nextValue, diff: (item.current || 0) - nextValue };
		});
		onUpdate(next);
	};

	return (
		<Box display="grid" gap={2} sx={{ width: '100%', height: '100%' }}>
			<Box display="flex" justifyContent="space-between" alignItems="center" marginBottom={1}>
				<Typography variant="h6">Alocação alvo por classe</Typography>
				<Box
					display="flex"
					alignItems="center"
					justifyContent="center"
					sx={{
						border: '1px solid #e0e0e0',
						borderRadius: 8,
						padding: '6px 10px',
						minWidth: 110,
						backgroundColor: '#fafafa'
					}}
				>
					<Typography variant="caption" color={remainingTarget === 0 ? 'success.main' : 'text.secondary'}>
						Restante: {remainingTarget}%
					</Typography>
				</Box>
			</Box>
			<Table size="small">
				<TableHead>
					<TableRow>
						<TableCell>Classe</TableCell>
						<TableCell align="right" width="70%">Distribuição</TableCell>
					</TableRow>
				</TableHead>
				<TableBody>
					{filteredAllocations.map((item) => (
						<TableRow key={item.label}>
							<TableCell sx={{ py: isCompact ? 0.5 : undefined }}>{item.label}</TableCell>
							<TableCell align="right" sx={{ maxWidth: 320, py: isCompact ? 0.5 : undefined }}>
								<Box display="flex" alignItems="center" gap={isCompact ? 0.75 : 1}>
									<TextField
										size="small"
										type="number"
										value={item.planned}
										onChange={(e) => handleManualTarget(item.label, e.target.value)}
										inputProps={{ inputMode: 'numeric', min: 0, max: 100, style: { textAlign: 'center' } }}
										sx={{
										width: isCompact ? 56 : 72,
										'& input': {
											padding: isCompact ? '6px 6px' : undefined,
											textAlign: 'center',
											MozAppearance: 'textfield'
										},
										'& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button': {
											margin: 0,
											WebkitAppearance: 'none'
										}
									}}
								/>
									<Box sx={{ flex: 1 }}>
										<Box display="flex" alignItems="center" gap={isCompact ? 0.75 : 1}>
											<IconButton
												size="small"
												tabIndex={-1}
												onClick={() => handleAdjustTarget(item.label, -1)}
											>
												<RemoveIcon fontSize="small" />
											</IconButton>
											<Slider
												value={item.planned}
												onChange={(_, val) => handleManualTarget(item.label, val)}
												step={1}
												min={0}
												max={100}
												valueLabelDisplay="auto"
												sx={{ height: isCompact ? 6 : 8 }}
												tabIndex={-1}
											/>
											<IconButton
												size="small"
												tabIndex={-1}
												onClick={() => handleAdjustTarget(item.label, 1)}
											>
												<AddIcon fontSize="small" />
											</IconButton>
										</Box>
									</Box>
								</Box>
							</TableCell>
						</TableRow>
					))}
				</TableBody>
			</Table>
			<Box display="flex" justifyContent="center" alignItems="center">
				{onSave ? (
					<Button
						variant="contained"
						color="primary"
						onClick={onSave}
						disabled={isSaving}
					>
						{isSaving ? 'Salvando...' : 'Salvar'}
					</Button>
				) : null}
			</Box>
		</Box>
	)
}

export default AssetTypeAllocation
